/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * * `ASSISTANT_MEDICAL_DIRECTOR` - Assistant Medical Director
 * * `CLINICAL_DIRECTOR` - Clinical Director
 * * `MEDICAL_DIRECTOR` - Medical Director
 * * `ONBOARDING` - Onboarding
 * * `PLACEMENT_LEAD` - Placement Lead
 * * `SCHEDULER` - Scheduler
 */
export enum RoleEnum {
    ASSISTANT_MEDICAL_DIRECTOR = 'ASSISTANT_MEDICAL_DIRECTOR',
    CLINICAL_DIRECTOR = 'CLINICAL_DIRECTOR',
    MEDICAL_DIRECTOR = 'MEDICAL_DIRECTOR',
    ONBOARDING = 'ONBOARDING',
    PLACEMENT_LEAD = 'PLACEMENT_LEAD',
    SCHEDULER = 'SCHEDULER',
}
